import { apiUrl } from "../environment";

export const REGISTER = apiUrl + "auth/signup";
export const LOGIN = apiUrl + "auth/signin";
export const GET_USER = "users/getUserData";
export const VERIFY_EMAIL = "users/updateEmail";
export const SEND_BVN = "users/sendVerifyBVNOTP";
export const VERIFY_BVN = "users/verifyBVNWithOTP";
export const ACC_BALANCE = "transactions/getAccountBalance";
export const TRANSACTIONS = "transactions/getUserTransactions";
export const CREATE_PIN = "users/createTransactionPin";
export const GET_BENE = "transactions/getBeneficiaries";
export const GET_DEBIT = "/transactions/getUserDebitTransactions";
export const GET_CREDIT = "/transactions/getUserCreditTransactions";
export const BANK_CODE = "https://api.lenco.ng/access/v1/banks";
export const TRANSFER = "transactions/recordTransfer";
export const CREATE_BUSINESS = "users/createOrganization";
export const GET_FLOW = "transactions/getFlowsThisMonth";
export const GET_SIGNATORIES = "users/getUsersByType";
export const CREATE_SIGN = "users/createUser";
export const SEND_PASS_OTP = "users/sendPasswordResetOtp";
export const UPDATE_PASS = "users/updatePassword";
export const VERIFY_PASS_OTP = "users/verifyResetPassword";
export const SEND_EMAIL_TOKEN = "users/sendEmailToken";
export const GET_PAYMENT = "transactions/getUserTransactionRequests";
export const APPROVE = "transactions/updateTransactionRequest";
export const GET_APP_PAYMENT =
  "transactions/getCompletedUserTransactionRequests";
export const VERIFY_ACC = (account = "", code = "") =>
  `https://api.lenco.ng/access/v1/resolve?accountNumber=${account}&bankCode=${code}`;
